import React from 'react';
import minimalLogo from '@/assets/images/ZelosMinimal.png'; // ✅ Confirm path is correct

const MinimalLogo = ({ className = "h-6 w-auto" }) => {
  return (
    <img
      src={minimalLogo}                        // ✅ Image source
      alt="Zelospace Minimalist Logo"          // ✅ Accessible alt text
      className={className}                    // ✅ Accepts custom styling (e.g. size/alignment)
    />
  );
};

export default MinimalLogo;